module.exports = __webpack_public_path__ + "static/media/icon-team-personality-high.bdf77876.svg";